// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { get } from "lodash";

const styles = ({ color, fontSize, fontWeight, lineHeight, typography }) => ({
  container: {
    backgroundColor: get(color, 'white'),
    padding: '0px 36px 0 36px',
    paddingTop: '20px',
    color: get(color, 'link'),
    fontSize: get(fontSize, 'fontSize.bodyText'),
    fontWeight: get(fontWeight, 'semiBold'),
    lineHeight: get(lineHeight, 'lh21'),
    textTransform: 'uppercase',
    '& .MuiBreadcrumbs-separator': {
      marginTop: '2px',
      fontSize: '10px',
    },
  },
  pageContainer: {
    margin: '0px 36px 0 36px',
  },
  nameContainer: {
    paddingTop: '2px',
    fontSize: '10px',
  },
  linkContainer: {
    fontSize: '10px !important',
    fontFamily: get(typography, 'pageTitle'),
  },
});

export default styles;
